module.exports = __webpack_public_path__ + "c666123be25a3f856b9673447237db73.svg";